import React from "react";
import Header from "../../commonComponents/header/Header.js";
import Footer from "../../commonComponents/footer/Footer.js";

const AccessDenied = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white pt-4 px-4">
      <Header />
      <div className="flex-1 flex justify-center items-center">
        <div className="text-center max-w-2xl mx-auto p-8">
          <div className="mb-6">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-red-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
            </div>
          </div>
          <h2 className="text-5xl font-medium mb-4 text-fontColor text-overFontSize">
            Access Denied
          </h2>

          <p className="text-fontColor text-lg mb-6 leading-relaxed">
            You don't have permission to view this screen. Please check your
            access link in the email.
          </p>

          <div className="text-fontColor text-md leading-relaxed text-left">
            <p className="mb-2">
              <strong>Note:</strong>
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                If your assessment was interrupted (refresh, network issue, or
                accidental exit), reopen the assessment link from your email.
                Your progress will be saved and you can continue.
              </li>
              <li>
                If you are trying to access this page without the original
                assessment link, please use the link shared in your email.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AccessDenied;
